import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './WhyCausee.module.css';

// Distinct line icons echoing the design mockup, drawn inline so the section
// needs no extra image assets. Each renders white on the green circular tile.
const PieIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3a9 9 0 1 0 9 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 3v9h9a9 9 0 0 0-9-9Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

const ChooseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11m0-1.5a1.5 1.5 0 0 1 3 0V12m0-1a1.5 1.5 0 0 1 3 0v4.5a4.5 4.5 0 0 1-4.5 4.5h-1.7a4 4 0 0 1-3-1.4L6 16.5a1.6 1.6 0 0 1 2.4-2.1L9 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShieldIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3l7 3v5c0 4.4-3 8.2-7 9-4-0.8-7-4.6-7-9V6l7-3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CommunityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="2" />
    <path d="M3.5 19a5.5 5.5 0 0 1 11 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M16 6.2a3 3 0 0 1 0 5.6M17 19a5.5 5.5 0 0 0-3-4.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const REASONS = [
  {
    Icon: PieIcon,
    labelId: 'CustomLandingPage.whyCausee.reason.profits.label',
    descriptionId: 'CustomLandingPage.whyCausee.reason.profits.description',
  },
  {
    Icon: ChooseIcon,
    labelId: 'CustomLandingPage.whyCausee.reason.decide.label',
    descriptionId: 'CustomLandingPage.whyCausee.reason.decide.description',
  },
  {
    Icon: ShieldIcon,
    labelId: 'CustomLandingPage.whyCausee.reason.secure.label',
    descriptionId: 'CustomLandingPage.whyCausee.reason.secure.description',
  },
  {
    Icon: CommunityIcon,
    labelId: 'CustomLandingPage.whyCausee.reason.community.label',
    descriptionId: 'CustomLandingPage.whyCausee.reason.community.description',
  },
];

const WhyCausee = () => {
  return (
    <div className={css.cardGrid}>
      {REASONS.map(({ Icon, labelId, descriptionId }) => (
        <div className={css.card} key={labelId}>
          <span className={css.cardIcon} aria-hidden="true">
            <Icon />
          </span>
          <div className={css.cardContent}>
            <h4 className={css.cardLabel}>
              <FormattedMessage id={labelId} />
            </h4>
            <span className={css.cardDescription}>
              <FormattedMessage id={descriptionId} />
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WhyCausee;
